export default __webpack_public_path__ + "static/media/Section4Picture.94564fe8.png";